export default {
  BAndRText: "Livres & Avis",
  Srchbook: "Rechercher par livre",
  offlisugg: "Suggestions d'Ofellio ",
  recentlyRated: "Récemment notés",



  // ReviewPage
  rewbtn1: "Vouloir lire",
  rewbtn2: "Écrire une critique",
  rewbtn3: "Utiliser pour Book Duo",
  rateBook: "Noter ce livre",
  buyon: "Acheter sur",
  Read: "Lu",
  reviewtext: "Critique",
  ratingtext: "Votre note",
  readon: "Lu sur",
  book: "Livre",
  ebook: "E-book",
  audiobook: "Livre audio",
  revTitle: "Titre de la critique",
  submitbtn: "Soumettre",


  // Book Duo Page
  yourbd: "Votre Book Duo",
  serchbook: "Rechercher un livre",
  DidText: "Vous n'avez pas trouvé votre livre? Entrez les détails!",
  city: "Ville",
  type: "Type",
  lookigfr: "Je cherche",
  male: "Homme",
  female: "Femme",
  idk: "Peu importe",
  agerg: "Tranche d'âge",
  language: "Langue",
  detil: "Détails ",
  optnal: "Optionnel",
  lookiginsp: "Quelques suggestions",
  suggbokduo: "Livres suggérés pour un Book Duo",
  seemoresugg: "Voir plus de suggestions",
  bokcvr: "Couverture du livre ",
  title: "Titre",
  writer: "Écrivain ",
  genre: "Genre",
  upload: "Télécharger ",
  add: "Ajouter ",
  online: "En ligne"
  , onlink: "Ajouter le lien de l'appel vidéo (Teams, Zoom, Google Meet etc)",
  noBookSelected: "Aucun livre sélectionné",
  loading: "Chargement...",
  noResultsFound: "Aucun résultat trouvé",
  meetingLink: "Lien de la réunion",
  noLimit: "Sans limite",
  languageTooltip: "C'est la langue que les participants parleront pendant le Book Duo.",
  languageTooltipBookClub: "C'est la langue que les participants parleront pendant le Book Club.",
  updating: "Mise à jour...",
  publishing: "Publication...",
  update: "Mettre à jour",
  noBooksFound: "Aucun livre trouvé sous cette suggestion pour un 1:1.",
  wellDone: "Bien joué !",
  bookDuoLive: "Votre Book Duo est maintenant en ligne.",
  willInformInterest: "Nous vous informerons lorsque quelqu'un manifestera de l'intérêt !",
  seeOn: "Voir sur",
  map: "Carte",


  // Book Club Page
  when: "Quand",
  time: "Heure ",
  age: "Âge",
  publsbtn: "Publier ",
  day: "Jour",
  month: "Mois",
  year: "Année",
  hour: "Heure",
  min: "Min",
  max: "Max",
  selectTime: "Sélectionner l'heure",
  selectLanguage: "Sélectionner la langue",
  selectType: "Sélectionner le type",
  inPerson: "En personne",
  attendees: "Participants",
  eventDetails: "Détails de l'événement",

  // Silent Reading Page
  where: "Où",
  venue: "Lieu",
  address: "Adresse",



// BookAnd Review page Event
  welc: "Bienvenue",
  memb: "Membre",
  exploreText: "Découvrez et rejoignez les événements disponibles ou créez le vôtre.",
  sbybooks: "Rechercher par titre",
  month: "Mois",
  sortby: "Trier par",
  cbduo: "Créer un Book Duo",
  smoreevent: "Voir plus d'événements",
  dowant: "Souhaitez-vous créer votre propre événement ?",
  ledAmbsdr: "Les Book Clubs et Silent Readings sont animés par des Ambassadors.",
  bAnAmbsdor: "Devenir Ambassador",
  leadText: "pour en animer un ou découvrir et rejoindre",
  evtnear: "des événements près de chez vous.",
  BookDuoFirstText: `Vous cherchez une connexion authentique ? Un Book Duo est parfait pour vous !`,
  BookDuoSecondText: `Choisissez un livre, indiquez le genre et la tranche d’âge de la personne avec qui vous souhaitez échanger, et vous êtes prêt. Dès que quelqu’un montrera de l’intérêt, vous pourrez discuter et organiser les détails de votre rencontre en tête-à-tête.`,

  BookClubFirstText: `Découvrez des clubs de lecture en personne près de chez vous ou en ligne, organisés dans des lieux chaleureux comme des cafés, des bars ou via visioconférence.`,
  BookClubSecondText: `Chaque Book Club Ofellio accueille jusqu’à 8 participants regroupés par tranche d’âge pour une expérience confortable. Un Ambassador Ofellio anime la discussion afin de garantir une ambiance vivante et inclusive.`,

  BookSilentFirstText: `Dans un cadre paisible et agréable, les sessions de Silent Reading offrent un moment de calme à jusqu’à 10 lecteurs.`,
  BookSilentSecondText: `Guidée par un Ambassador Ofellio, chaque session vous invite à apporter votre propre livre, lire en silence et, si vous le souhaitez, échanger avec les autres dans une atmosphère détendue.`,

  DuoBtnText: `Créer un Book Duo`,
  ClubBtnText: `Créer un Book Club`,
  SilentBtnText: `Créer un Silent Reading`,
  bookDuoTitle: "Book Duo",
  bookClubTitle: "Book Club",
  bookSilentTitle: "Silent Reading",



// BOOK_CLUB DUO SILENTREADING
  yownbook: "Votre propre livre",
  resetFilters: "Réinitialiser les filtres",
  resetAll: "Tout réinitialiser",
  applyFilters: "Appliquer les filtres",
  filters: "Filtres",
  full: "COMPLET",
  booked: "Complet",
  open: "Ouvert",
  buyon: "Acheter sur",
  gender: "Genre",
  locatedin: "Situé à",
  aboutbook: `À propos du livre`,
  readmore: `Lire plus`,
  readless: `Lire moins`,
  details: "Détails",
  totalspot: "Places totales",
  spotleft: "Places restantes",
  join: "Participer",
  share: "Partager",
  cregistration: "Complétez votre inscription",
  registrationmsg: "Votre e-mail sera partagé avec l’Ambassador",
  welldone: "Bravo !",
  attending: "Vous participez à ",
  attendmsg: "Vous pouvez maintenant voir cet événement dans votre tableau de bord Ofellio et discuter avec votre Ambassador",
  thankyou: "Merci !",
  thankmsg: "L’organisateur a été informé de votre intérêt et peut vous écrire pour finaliser les détails de ce Book Duo",

  // CHAT PAGE
  msgtext: "Messages ",
  vprofile: "Voir le profil",
  mute: "Mettre en sourdine",
  block: "Bloquer",
  unblock: "Débloquer",
  report: "Signaler",

  // Setting Page
  pprofile: "Profil personnel",
  accnotifi: "Notifications",
  uploadp: "Télécharger une photo",
  name: "Nom",
  surname: "Nom de famille",
  dob: "Date de naissance",
  aboutme: "À propos de moi",
  country: "Pays",
  favgenre: "Genres préférés",
  asmedia: "Ajoutez vos réseaux sociaux ci-dessous",
  savechgbtn: "Enregistrer les modifications",

  cypass: "Changer votre mot de passe",
  cypasstext: "Lorsque vous changez votre mot de passe, vous serez automatiquement déconnecté de vos autres sessions",
  cpass: "Changer le mot de passe",
  cyemail: "Changer votre e-mail",
  cyemailtext: "Lorsque vous changez votre e-mail, vous serez automatiquement déconnecté de vos autres sessions",
  cemail: "Changer l'e-mail",
  notifi: "Notification ",
  emailmeab: "Envoyez-moi des e-mails concernant",
  lastesttext: "Derniers livres tendance",
  upcomtext: "Nouveaux livres du mois à venir",
  baevent: "Livres, auteurs et événements que j'aimerais",
  newoff: "Nouvelles fonctionnalités Ofellio",

  curnpass: "Mot de passe actuel",
  newpass: "Nouveau mot de passe",
  cnewpass: "Confirmer le nouveau mot de passe",
  curnemail: "E-mail actuel",
  newemail: "Nouvel e-mail",
  cnewemail: "Confirmer le nouvel e-mail",
  delyacc: "Supprimer votre compte ",
  sorrytext: "Nous sommes désolés que vous souhaitiez nous quitter !",
  suretext: "Êtes-vous sûr de vouloir faire cela ? ",
  decitext: "Si vous décidez d'utiliser Ofellio à nouveau, vous devrez créer un nouveau compte.",
  pass: "Mot de passe",

  // meun
  jan: "Janvier",
  feb: "Février",
  mar: "Mars",
  apr: "Avril",
  may: "Mai",
  jun: "Juin",
  jul: "Juillet",
  aug: "Août",
  sep: "Septembre",
  oct: "Octobre",
  nov: "Novembre",
  dec: "Décembre",
  // Month abbreviations
  monthAbbrJan: "Janv",
  monthAbbrFeb: "Févr",
  monthAbbrMar: "Mars",
  monthAbbrApr: "Avr",
  monthAbbrMay: "Mai",
  monthAbbrJun: "Juin",
  monthAbbrJul: "Juil",
  monthAbbrAug: "Août",
  monthAbbrSep: "Sept",
  monthAbbrOct: "Oct",
  monthAbbrNov: "Nov",
  monthAbbrDec: "Déc",
  cri: "Policier",
  fic: "Fiction",
  grpnvl: "Romans graphiques et manga",
  yng: "Jeunes adultes et LGBTQ+",
  nonfic: "Non-fiction",
  scifan: "Science-fiction et fantastique",
  others: "Autres",
  morerec: "Plus récent",
  lessrec: "Moins récent ",

  // HeaderProfil
  setg: "Paramètres ",
  logout: "Déconnexion",


  // dashbords pages
  editprf: "Modifier le profil",
  cbduo: "Créer Book Duo",
  joining: "Je participe",
  bandrew: "Livres et Avis",
  upcomclub: "Prochains Book Clubs",
  upcomduo: "Prochains Book Duos",
  upcomsil: "Prochaines Lectures Silencieuses",
  allpst: "Tous les événements passés",
  edit: "Modifier",
  going: "Je vais",
  ngoing: "Je ne vais pas",
  cancel: "Annuler",

  level: "Niveau ",
  cbclub: "Créer Book Club",
  cbsil: "Créer Silent Reading",
  loyprog: "Programme de fidélité",
  mang: "Gérer",
  attlist: "Liste des participants",
  event: "Annuler RSVP",
  chatgroup: "Discuter avec le groupe",
  chatambas: "Discuter avec l'Ambassadeur",
  bookshelv: "Bibliothèques de",
  reviews: "Avis",

  // Leading Page
  ambassador: "Ambassador",
  member: "Membre",
  level1: "Niveau 1",
  level2: "Niveau 2",
  level3: "Niveau 3",
  level4: "Niveau 4",
  toLevel: "à",
  highestLevel: "🎉 Vous avez atteint le niveau le plus élevé !",
  editProfile: "Modifier le profil",
  createBookClub: "Créer Book Club",
  createSilentReading: "Créer Silent Reading",
  createBookDuo: "Créer Book Duo",
  createEvent: "+ Créer un événement",
  attendeesList: "Liste des participants",
  wantToRead: "Vouloir lire",
  remove: "Supprimer",
  tbd: "À déterminer",
  full: "COMPLET",
  yourOwnBook: "Votre propre livre",
  ageLabel: "Âge :",
  manage: "Gérer",
  cancelRSVP: "Annuler RSVP",
  imLeading: "Je dirige",
  imJoining: "Je participe",
  booksAndReviews: "Livres et Avis",
  loyaltyProgram: "Programme de fidélité",
  upcomingBookClubs: "Prochains Book Clubs",
  upcomingSilentReadings: "Prochains Silent Readings",
  upcomingBookDuos: "Prochains Book Duos",
  noEventsToShow: "Aucun événement à afficher.",
  wantToReadLower: "Vouloir lire",
  readLower: "Lu",
  reviewsLower: "Avis",
  noRatedBooks: "Vous n'avez encore évalué aucun livre.",
  giftsDiscounts: "Cadeaux et réductions sur la lecture",
  loyaltyDescription: "Plus vous lisez, plus vous gagnez ! Profitez de réductions et d'avantages en montant de niveau.",
  starterReader: "Lecteur débutant",
  starterReaderDesc: "Commencez votre parcours en tant qu'Ambassador Ofellio et commencez à diriger vos premières expériences de lecture.",
  starterReaderReward: "Reconnaissance précoce et accès aux futurs avantages d'Ambassador.",
  communityBuilder: "Constructeur de communauté",
  communityBuilderDesc: "Continuez à connecter les lecteurs et à créer des événements de livres engageants au sein de votre communauté.",
  communityBuilderReward: "Accès prioritaire aux nouvelles fonctionnalités et mises à jour exclusives.",
  proHost: "Hôte professionnel",
  proHostDesc: "Vous façonnez des moments de lecture significatifs et inspirez les autres grâce à vos événements.",
  proHostReward: "Invitations aux prochaines initiatives Ofellio et surprises spéciales.",
  legend: "Légende",
  legendDesc: "Continuez à inspirer les lecteurs du monde entier — votre leadership façonne la communauté Ofellio.",
  legendReward: "Débloquez une reconnaissance exclusive et des avantages en évolution.",
  attendees: "Participants",
  noAttendeesYet: "Aucun participant pour le moment.",
  // Modal translations for add book manually
  booksCover: "Couverture du livre",
  writerLabel: "Écrivain",
  genreLabel: "Genre",
  aboutTheBookLabel: "À propos du livre",
  addButton: "Ajouter",
  chatWithGroup: "Discuter avec le groupe",
  cancelEvent: "Annuler l'événement",
  cancelRSVPConfirm: "Êtes-vous sûr de vouloir annuler votre RSVP ?",
  cancelEventConfirm: "Êtes-vous sûr de vouloir annuler cet événement ?",
  cancelRSVPEmail: "Un e-mail d'annulation sera envoyé à l'Ambassador.",
  cancelEventEmail: "Un e-mail d'annulation sera envoyé aux participants actuels.",

  // How It Works Section
  howOfellioWorks: "Comment fonctionne Ofellio",
  howItWorksDesc: "Découvrez de nouvelles façons de vous connecter à travers les livres — que ce soit en tête-à-tête, en groupe ou dans des sessions de lecture silencieuse paisibles.",
  bookDuoTitle: "Book Duo",
  bookDuoDesc: "Vous cherchez une connexion personnelle ? Choisissez un livre, sélectionnez l'âge et le genre préférés du partenaire et commencez un voyage littéraire en tête-à-tête.",
  bookClubTitle: "Book Club",
  bookClubDesc: "Rejoignez des Book Clubs accueillants en personne ou en ligne organisés dans des lieux chaleureux. Chaque groupe est animé par un Ambassador pour assurer une expérience dynamique et inclusive.",
  silentReadingTitle: "Silent Reading",
  silentReadingDesc: "Profitez de sessions de lecture silencieuse paisibles. Apportez votre propre livre, détendez-vous et partagez la joie tranquille de lire ensemble.",
  exploreThe: "Explorez les",
  existingEvents: "événements existants",
  or: "ou",
  createYourOwn: "créez le vôtre",
  joinOfellio: "Rejoignez Ofellio",
  signUp: "S'inscrire",
  chooseYourCountry: "Choisissez votre pays",
  joined: "rejoint",
  joinedCapitalized: "Rejoint",
  shareThisEvent: "Partager cet événement",
  linkVisibleAttendees: "Lien visible uniquement par les participants",
  recentReviews: "Avis récents",
  noReviewsAvailable: "Aucun avis disponible",
  writeAReview: "Écrire un avis",
  yourRating: "Votre note",
  update: "Mettre à jour",
  aboutTheBook: "À propos du livre",
  makeAChoiceForThisBook: "Faites un choix pour ce livre",
  howDidYouReadIt: "Comment l'avez-vous lu?",
  noRating: "Aucune note",
  reviewPublished: "Avis publié",
  useForBookDuo: "Utiliser pour Book Duo",
  yourReview: "Votre avis",
  addAShortTitle: "Ajouter un titre court",
  shareYourThoughts: "Partagez vos pensées sur ce livre...",
  send: "Envoyer",
  bookclubLive: "Bravo ! Votre Bookclub est maintenant en ligne et les participants peuvent s'y inscrire.",
  silentReadingLive: "Bravo ! Votre Lecture Silencieuse est maintenant en ligne et les participants peuvent s'y inscrire.",
  dashboard: "Tableau de bord",

  // Day abbreviations
  dayMon: "Lun",
  dayTue: "Mar",
  dayWed: "Mer",
  dayThu: "Jeu",
  dayFri: "Ven",
  daySat: "Sam",
  daySun: "Dim",
  
  // Additional translations
  ambassadorLabel: "Ambassador:",
  createdBy: "Créé par:",
  youAreAttendingThis: "Vous participez à ce",
  youCanNowSeeThisEvent: "Vous pouvez maintenant voir cet événement dans votre tableau de bord Ofellio et discuter",
  withYourAmbassador: "avec votre Ambassador",
  chatWithAmbassador: "Discuter avec Ambassador",
  yourRequestHasBeenSent: "Votre demande a été envoyée à l'ambassador",
  sentYouAMessage: "vous a envoyé un message!",
  justJoinedYour: "a rejoint votre",
  bookClubsAndSilentReadings: "Les Book Clubs et Silent Readings sont animés par des Ambassadors.",
  becomeAnAmbassador: "Devenir Ambassador",
  toLeadOneOrExplore: "pour en animer un ou découvrir et rejoindre",
  eventsAvailable: "événements disponibles.",
};
